import axios from 'axios'

const epromo = axios.create({
  timeout: 10000,
  headers: {
    'Authorization': 'Iu5WNJzQzgBVX4Per3jwMnjhdm0PB0TGfOl5Nd5XdppUQgLT8QGTI7j6PGXIWgn',
    'Content-Type': 'application/json'
  }
})

export default epromo



// WEBPACK FOOTER //
// ./src/services/epromo.js